import { ArrowRight } from "@gravity-ui/icons";
import {
  Button,
  Flex,
  Icon,
  SegmentedRadioGroup,
  Text,
} from "@gravity-ui/uikit";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { appConfig } from "src/config";
import { useTranslate } from "src/i18n";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { RatesWidget } from "src/widgets";

export const SubscribePage = () => {
  const { t } = useTranslate();
  return (
    <>
      <Helmet>
        <title>{appConfig.displayName} · Консоль · Подписки</title>
      </Helmet>

      <Link to={RoutesPaths.LK.SUBSCRIBE_OLD}>
        <Button view="flat">
          Калькулятор тарифов
          <Icon data={ArrowRight} />
        </Button>
      </Link>

      <Flex justifyContent={"center"}>
        <Text variant="display-2" style={{ textAlign: "center" }}>
          Информация и цены на тарифные планы
        </Text>
      </Flex>

      <Flex justifyContent={"center"} style={{ marginTop: 32 }}>
        <SegmentedRadioGroup size="l" defaultValue="month">
          <SegmentedRadioGroup.Option value="month">
            Ежемесячная оплата
          </SegmentedRadioGroup.Option>
          <SegmentedRadioGroup.Option
            disabled
            value="year"
            title={t("subscribe.annual.tooltip", "Скоро")}
          >
            Ежегодная оплата
          </SegmentedRadioGroup.Option>
        </SegmentedRadioGroup>
      </Flex>

      <RatesWidget />
    </>
  );
};
